/**
 * keepr's default time zone.
 *
 * The owner's ruling (analytics q06, 2026-09-29): charts count days, weeks and
 * months in a time zone set on the collection — "default the collection time
 * zone to US/Pacific (this is the keepr default timezone)". A collection that
 * sets none uses the nearest collection above it that does, and a top-level
 * one uses this (docs/plans/analytics.md §4.4, ⚑ d31, d32).
 *
 * `America/Los_Angeles` is the canonical IANA name for the deprecated alias
 * `US/Pacific`. It MUST match keepr-api `utils/timezone.js`
 * `PLATFORM_TIMEZONE`: the server resolves every zone a chart counts in, and
 * this copy exists only so the settings form can name keepr's default when a
 * response does not carry it.
 *
 * A person's own `timezone` preference (config/preferenceDefs.js) is a
 * different setting — their quiet hours and notifications.
 */
export const PLATFORM_TIMEZONE = 'America/Los_Angeles';
